<template>
    <div class="c-group-header">
        <v-list-item>
            <v-list-item-content>
                <v-list-item-title class="text-h4 font-weight-bold">
                {{ primaryFarm?.farmName }}
                </v-list-item-title>
                <v-list-item-subtitle>
                #FARM{{ primaryFarm?.id }}
                </v-list-item-subtitle>
            </v-list-item-content>
        </v-list-item>
        <v-card flat>
            <v-card-title>
                <v-row class="elevation-0" width="100%">
                    <v-col cols="1.5" class="">
                        <v-list dense>
                            <v-list-item>
                                <v-list-item-content>
                                    <v-list-item-subtitle>
                                        {{ $t("farmName") }}
                                    </v-list-item-subtitle>
                                    <v-list-item-title class="text-h6 mt-2 text-capitalize">
                                        {{ primaryFarm?.farmName }}
                                    </v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list>
                    </v-col>
                    <v-divider vertical inset></v-divider>
                    <v-col cols="1.5" class="">
                        <v-list dense>
                            <v-list-item>
                                <v-list-item-content>
                                    <v-list-item-subtitle>
                                        {{ $t("farmOwner") }}
                                    </v-list-item-subtitle>
                                    <v-list-item-title class="text-h6 mt-2 text-capitalize">
                                        {{ primaryFarm?.farmOwner }}
                                    </v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list>
                    </v-col>
                    <v-divider vertical inset></v-divider>
                    <v-col cols="1.5" class="">
                        <v-list dense>
                            <v-list-item>
                                <v-list-item-content>
                                    <v-list-item-subtitle>
                                        {{ $t("govRegistrationNum") }}
                                    </v-list-item-subtitle>
                                    <v-list-item-title class="text-h6 mt-2 text-capitalize">
                                        {{ primaryFarm?.govRegistrationNum }}
                                    </v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list>
                    </v-col>
                    <v-divider vertical inset></v-divider>
                    <v-col cols="1.5" class="">
                        <v-list dense>
                            <v-list-item>
                                <v-list-item-content>
                                    <v-list-item-subtitle>
                                        {{ $t("cooperativeId") }}
                                    </v-list-item-subtitle>
                                    <v-list-item-title class="text-h6 mt-2 text-capitalize">
                                        {{ primaryFarm?.cooperativeId }}
                                    </v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list>
                    </v-col>
                    <v-divider vertical inset></v-divider>
                    <v-col cols="1.5" class="">
                        <v-list dense>
                            <v-list-item>
                                <v-list-item-content>
                                    <v-list-item-subtitle>
                                        {{ $t("dateOfRegistration") }}
                                    </v-list-item-subtitle>
                                    <v-list-item-title class="text-h6 mt-2 text-capitalize">
                                        {{ primaryFarm?.createdAt }}
                                    </v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list>
                    </v-col>
                </v-row>
            </v-card-title>
        </v-card>
    </div>
</template>

<script>
export default {
    props: {
        primaryFarm: {
            required: true,
            type: Object,
        }
    }
}
</script>
